import { useTheme } from '@chakra-ui/react'
import React from 'react'
import '../../App.css'
import ArrowBUttonSvg from './ArrowButtonSvg';
import { useNavigate } from 'react-router-dom';

export default function ButtonMore({
  buttonText = 'CONOCÉ MÁS',
  redirectTo = '',
  customStyles,
  customActionsOnCLick = () => null
}) {
  const navigate = useNavigate();
  const theme = useTheme();
  const style = styles(theme, customStyles);
  return (
    <div onClick={() =>{ navigate(redirectTo); customActionsOnCLick()}} style={style.container} className="sansation-bold">
      <div style={style.text}>{buttonText}</div>
      <ArrowBUttonSvg {...style.arrowSvg} />
    </div>
  );
}

const styles = (theme, customStyles) => ({
    container:{
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: 0,
        backgroundColor: theme.background.tertiary,
        borderRadius: 5,
        cursor: 'pointer',
        ...customStyles?.container
    },
    text:{
        fontSize: '18px',
        color: theme.color.text.secondary,
        ...customStyles?.text
    },
    arrowSvg:{
      width:30,
      height:30,
      ...customStyles?.arrowSvg
    }
})
